var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrack = function SvgTrack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    d: "M10.4 4.31c.83 0 1.62.17 2.37.5a6.07 6.07 0 0 1-2.36 11.69 6 6 0 0 1-4.31-1.78 6.18 6.18 0 0 1-1.8-4.32v-.13h1.3v.13a4.81 4.81 0 0 0 2.93 4.42 4.7 4.7 0 0 0 3.73 0 4.81 4.81 0 0 0 2.55-2.56 4.7 4.7 0 0 0 0-3.73A4.81 4.81 0 0 0 12.27 6a4.7 4.7 0 0 0-1.86-.38h-.13v-1.3h.13ZM7.95 2.53a9.08 9.08 0 0 1 1.3 0v6.71h-6.7a9.08 9.08 0 0 1 0-1.3 6.02 6.02 0 0 1 2.82-4.5c.79-.5 1.65-.8 2.58-.9Zm-4.1 5.41h4.1v-4.1c-1.06.15-1.97.6-2.73 1.37a4.67 4.67 0 0 0-1.37 2.73Z"
  })));
};
export default SvgTrack;